<template>
  <div class="home-sys flex-center">
    <bcc-row
      :gutter="0"
      class="home-sys-row"
      type="flex"
      align="middle"
      justify="center"
    >
      <bcc-col span="3">
        <div class="home-sys-name">
          <img :src="require(`@/assets/home/logo_announcement.png`)"/>
        </div>
      </bcc-col
      >
      <bcc-col span="17">
        <div class="home-sys-list flex-align" v-if="noticeInfo && noticeInfo.list">
          <div
            class="home-sys-item"
            v-for="(item, index) in noticeInfo.list.slice(0, 2)"
            v-bind:key="index"
            @click="handleClick(index)"
          >
            <div class="home-sys-new" v-if="!index"></div>
            <div class="home-sys-title">
              <div class="c">{{item.title || '未知标题'}}</div>
              <div class="t">{{item.time}}</div>
            </div>
          </div>
        </div>
      </bcc-col
      >
      <bcc-col span="4">
        <div class="home-sys-btn" @click="handleClick('all')">
          <span>查看更多</span>
          <img :src="require(`@/assets/icon/ic_enter.png`)"/>
        </div>
      </bcc-col>
    </bcc-row>
  </div>
</template>

<script>

export default {
  name: 'Sys',
  data() {
    return {
      noticeInfo: null
    }
  },
  mounted() {
    this.getNotice()
  },
  computed: {
  },
  methods: {
    handleClick(sys_id) {
      this.$emit('handleClick', sys_id)
    },
    async getNotice() {
      await this.$api.sys
        .noticeList()
        .then((data) => {
          this.noticeInfo = data
        })
        .catch((e) => {
          this.$message({
            content: e.message,
            type: 'exception',
            offset: 60,
            duration: 1500
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.home-sys {
  width: 100%;

  &-row {
    width: 100%;
    max-width: 1440px;
    border: 4px solid #f7fbff;
    height: 72px;
    transition: all 0.5s ease-in-out;
  }

  &-item {
    display: flex;
    width: 50%;
    cursor: pointer;

    &:hover {
      .home-sys-title {
        .c {
          color: #00A1D6;
        }
      }
    }
  }

  &-name {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 120px;
      height: auto;
      margin-right: 10px;
    }
  }

  &-title {
    margin-left: 8px;
    width: calc(100% - 60px);
    .c {
      font-size: 16px;
      line-height: 32px;
      color: #222222;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .t {
      font-size: 14px;
      color: #999999;
      line-height: 14px;
    }
  }

  &-btn {
    font-size: 16px;
    color: #505050;
    line-height: 16px;
    text-align: right;
    margin-right: 36px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &:hover {
      color: #23ade5;
    }

    span {
      vertical-align: middle;
    }

    img {
      margin-left: 6px;
      vertical-align: middle;
      width: 16px;
      height: 16px;
    }
  }

  &-new {
    width: 40px;
    height: 24px;
    background: url("../../assets/home/tag_news.png") no-repeat;
    background-size: contain;
    position: relative;
    top: 8px;
    left: 3px;
  }
}
</style>
